export const PROJECT_STATUS_ACTIVE = 'active';
export const PROJECT_STATUS_ARCHIVED = 'archived';
export const PROJECT_STATUS_ARCHIVE = 'archived';
export const PROJECT_STATUS_DELETED = 'deleted';
export const STATUS_SESSION_STORAGE_KEY = 'status';

export const CARD_VIEW = 'Card';
export const TABLE_VIEW = 'Table';
export const PROJECT_VIEW_SESSION_KEY = 'ProjectView';
export const INITIAL_TABLE_VIEW_PAGE_SIZE = 10;
export const CARD_VIEW_PAGE_SIZE = 12;
export const MAX_PROJECTS_TO_SHOW_IN_CAROUSEL = 10;
export const MOBILE_WIDTH = 639;
export const MOBILE_MEDIA = '(max-width: 639px)';

export const SORT_KEY_PROJECT_NAME = 'PROJECT_NAME';
export const SORT_KEY_PROJECT_STATUS = 'STATUS';
export const SORT_KEY_PROJECT_ID = 'PROJECT_ID';
export const SORT_KEY_LAST_MODIFIED = 'LAST_MODIFIED';

// Analytics event names
export const PROJECTS_SUMMARY_VIEW_TYPE = 'projects: project summary view type';
export const PROJECTS_SORT_SEARCH = 'projects: sort and search';
export const PROJECTS_PAGINATION = 'projects: pagination';
export const PROJECT_ENTRY_POINT = 'projects: entry point';
export const PROJECTS_FILTER_DRAWER = 'projects: filter drawer';

// View type strings (used for analytics and general view identification)
export const CARD_VIEW_TYPE = 'card view';
export const TABLE_VIEW_TYPE = 'table view';

// Analytics action types
export const ANALYTICS_ACTION_SORT = 'sort';
export const ANALYTICS_ACTION_SEARCH = 'search';
export const ANALYTICS_ACTION_MIXED = 'mixed sort and search';

// Analytics clear types
export const ANALYTICS_CLEAR_FILTERS = 'clear filters';
export const ANALYTICS_FILTERS_DRAWER_RESET = 'filters drawer: reset filters';

// Analytics search format strings
export const ANALYTICS_PROJECT_NAME_A_TO_Z = 'project name:a to z';
export const ANALYTICS_PROJECT_NAME_Z_TO_A = 'project name:z to a';
export const ANALYTICS_PROJECT_NUMBER_A_TO_Z = 'project number:a to z';
export const ANALYTICS_PROJECT_NUMBER_Z_TO_A = 'project number:z to a';
export const ANALYTICS_PROJECT_STATUS_ACTIVE_FIRST = 'project status:active first';
export const ANALYTICS_PROJECT_STATUS_ARCHIVED_FIRST = 'project status:archived first';
export const ANALYTICS_LAST_MODIFIED_MOST_RECENT = 'last modified:most recent';
export const ANALYTICS_LAST_MODIFIED_OLDEST_FIRST = 'last modified:oldest first';

// Analytics search value strings
export const ANALYTICS_PROJECT_NAME_USER_ENTRY = 'project name:user entry';
export const ANALYTICS_PROJECT_NUMBER_USER_ENTRY = 'project number:user entry';
export const ANALYTICS_PROJECT_STATUS_ACTIVE = 'project status:active';
export const ANALYTICS_PROJECT_STATUS_ARCHIVED = 'project status:archived';
export const ANALYTICS_NOT_APPLICABLE = 'n/a';

export const LANDING_PAGE_UPDATED = 'https://assets.thdstatic.com/images/v1/projects/landing-page-updated.png';